export default function CTASection() {
  return (
    <section className="py-16 md:py-20 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20product%20photography%20backdrop%20with%20premium%20leather%20bag%20designer%20sunglasses%20elegant%20watch%20and%20textured%20accessories%20scattered%20organically%20on%20warm%20sand%20colored%20suede%20surface%2C%20soft%20golden%20hour%20side%20lighting%20creating%20dramatic%20yet%20gentle%20shadows%2C%20rich%20earth%20tone%20color%20palette%20with%20camel%20terracotta%20and%20cream%20accents%2C%20luxury%20editorial%20still%20life%20composition%2C%20warm%20inviting%20atmosphere%20with%20sophisticated%20texture%20layering&width=1600&height=700&seq=cta-fashion-bg-2026r2&orientation=landscape"
          alt="Premium fashion accessories and lifestyle products background for call to action"
          title="Explore Hipobuy Spreadsheet Products"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-black/25"></div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-white mb-4">
          Ready To Explore Better Product Research?
        </h2>
        <p className="text-white/80 text-sm md:text-base mb-8 max-w-lg mx-auto">
          Visit our main platform to access the complete Hipobuy Spreadsheet with thousands of products across all categories
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3.5 rounded-md text-base font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer inline-block"
          >
            Visit Main Platform
          </a>
          <a
            href="#categories"
            className="w-full sm:w-auto bg-white/90 hover:bg-white text-foreground-900 px-8 py-3.5 rounded-md text-base font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer inline-block"
          >
            Browse Categories
          </a>
        </div>
      </div>
    </section>
  );
}